import { theme } from '@/styles/theme';

export const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '100vh',
    padding: 2,
    [theme.breakpoints.down('sm')]: {
      maxWidth: '100%',
      padding: '16px',
    },
  },
  contentSuccess: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    paddingInline: 22,
    paddingBlock: 10,
    borderRadius: 4,
    [theme.breakpoints.down('sm')]: {
      paddingInline: '16px',
      paddingBlock: '8px',
    },
  },
  content: {
    backgroundColor: 'white',
    paddingInline: 22,
    paddingBlock: 10,
    borderRadius: 4,
    [theme.breakpoints.down('sm')]: {
      paddingInline: '16px',
      paddingBlock: '8px',
    },
  },
  header: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignContent: 'center',
    minWidth: '420px',
    [theme.breakpoints.down('sm')]: {
      minWidth: '100%',
    },
  },
  title: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: 'white',
    paddingBottom: '22px',
    [theme.breakpoints.down('sm')]: {
      paddingBottom: '16px',
    },
  },
  welcome_text: {
    whiteSpace: 'pre-line',
    paddingLeft: '16px',
    fontWeight: 400,
    fontSize: '18px',
    [theme.breakpoints.down('sm')]: {
      paddingLeft: '8px',
      fontSize: '16px',
    },
  },
  text: {
    whiteSpace: 'pre-line',
    fontWeight: 600,
    fontSize: '20px',
    color: theme.palette.primary.main,
    paddingTop: '32px',
    [theme.breakpoints.down('sm')]: {
      fontSize: '18px',
      paddingTop: '24px',
    },
  },
  button: {
    marginLeft: -1,
    paddingTop: 1,
    [theme.breakpoints.down('sm')]: {
      marginLeft: 0,
      paddingTop: '8px',
    },
  },
};
